import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-2 -mt-10 mb-8" }
const _hoisted_2 = { class: "flex items-center justify-between mb-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h4", { class: "mb-2" }, "Quiz", -1)
const _hoisted_4 = { class: "bg-white rounded-lg border border-gray-300" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Table = _resolveComponent("Table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_Button, {
        label: _ctx.$t('labels.generic', { pt: 'Baixar', en: 'Download' }),
        icon: "pi pi-download",
        class: "p-button-sm btn-primary h-9",
        loading: _ctx.btnLoading,
        onClick: _ctx.downloadCSV
      }, null, 8, ["label", "loading", "onClick"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_Table, {
        slotData: _ctx.performance,
        columns: _ctx.columns,
        loading: _ctx.loader,
        params: _ctx.params,
        filters: _ctx.filters,
        hasStatus: false,
        hasActions: false,
        actionsTitle: '',
        actions: _ctx.actions,
        onOnPaginate: _cache[0] || (_cache[0] = ($event: any) => (_ctx.paginate($event)))
      }, null, 8, ["slotData", "columns", "loading", "params", "filters", "actions"])
    ])
  ]))
}